module.exports = __webpack_public_path__ + "media/svg/neutral_dark_solo-74a0d168.svg";